module.exports = __webpack_public_path__ + "open-sans-latin-800.926d4d1229e98081302d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-800.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-800.svg
// module chunks = 1 3